// extracted by mini-css-extract-plugin
export default {"emotionForm":"EmotionForm_emotionForm__CQT5J","actionsWrapper":"EmotionForm_actionsWrapper__A1rSf"};